import React, { useState } from 'react'

export const SearchContext = React.createContext()

export const withSearchContext = Component => props => {
	const [searchString, setSearchString] = useState('')
	return(
		<SearchContext.Provider value={{ searchString, setSearchString }}>
			<Component {...props}/>
		</SearchContext.Provider>
	)
}
